import React from 'react';
import { Bell, Check, X } from 'lucide-react';
interface NotificationsPanelProps {
  isOpen: boolean;
  onClose: () => void;
}
export function NotificationsPanel({
  isOpen,
  onClose
}: NotificationsPanelProps) {
  if (!isOpen) return null;
  const notifications = [{
    id: 1,
    title: 'Auction Ending Soon',
    msg: 'Hinjewadi Phase 3 auction closes in 2 hours.',
    time: '10m ago',
    unread: true
  }, {
    id: 2,
    title: 'New Bid Received',
    msg: 'Bid of ₹1.45 Cr received for Plot #42.',
    time: '1h ago',
    unread: true
  }, {
    id: 3,
    title: 'Compliance Alert',
    msg: 'Sunrise Developers submitted RERA docs.',
    time: '3h ago',
    unread: false
  }, {
    id: 4,
    title: 'System Update',
    msg: 'Platform maintenance scheduled for Sunday.',
    time: '1d ago',
    unread: false
  }];
  return <div className="absolute top-full right-0 mt-2 w-80 bg-white border border-gray-300 shadow-lg z-50 rounded-sm" data-id="element-942">
      <div className="p-3 border-b border-gray-200 flex justify-between items-center bg-gray-50" data-id="element-943">
        <h3 className="font-bold text-sm flex items-center gap-2" data-id="element-944">
          <Bell className="w-4 h-4" data-id="element-945" /> Notifications
        </h3>
        <button onClick={onClose} className="text-gray-400 hover:text-gray-600" data-id="element-946">
          <X className="w-4 h-4" data-id="element-947" />
        </button>
      </div>

      <div className="max-h-96 overflow-y-auto" data-id="element-948">
        {notifications.map(notif => <div key={notif.id} className={`p-3 border-b border-gray-100 hover:bg-gray-50 cursor-pointer ${notif.unread ? 'bg-blue-50/50' : ''}`} data-id="element-949">
            <div className="flex justify-between items-start mb-1" data-id="element-950">
              <span className={`text-sm font-bold ${notif.unread ? 'text-[#1f2933]' : 'text-gray-600'}`} data-id="element-951">
                {notif.title}
              </span>
              <span className="text-[10px] text-gray-400" data-id="element-952">{notif.time}</span>
            </div>
            <p className="text-xs text-gray-600 leading-relaxed" data-id="element-953">{notif.msg}</p>
          </div>)}
      </div>

      <div className="p-2 border-t border-gray-200 bg-gray-50 text-center" data-id="element-954">
        <button className="text-xs font-bold text-blue-600 hover:underline" data-id="element-955">
          Mark all as read
        </button>
      </div>
    </div>;
}